import AddressLookup from './AddressLookup';

const AddressLookupController = {
    init: function () {
        this.initHomepageAddressLookup();
    },
    initHomepageAddressLookup: function () {
        const selectorTarget = '[data-homepage-address-lookup]',
            postURL = '/HomeCW/SearchResultByGeoLocation';
        var geoLocation;
        var addressLookupController = this;
        window.JustEat = window.JustEat || {};
        window.JustEat.loggingTargets = window.JustEat.loggingTargets || {};
        window.JustEat.loggingTargets.homepageAddressLookup = AddressLookup.attach(selectorTarget, {
            onConfirm: function onConfirm () {
                if (this.options.existingLocationData && !this.lookup.inputs.fullAddress.dirty) {
                    geoLocation = {
                        latitude: this.options.existingLocationData.latitude,
                        longitude: this.options.existingLocationData.longitude,
                        postcode: this.options.existingLocationData.postcode,
                        sublocality: this.options.existingLocationData.sublocality,
                        state: this.options.existingLocationData.state,
                        city: this.options.existingLocationData.locality,
                        houseNo: this.options.existingLocationData.streetNumber,
                        street: this.options.existingLocationData.street,
                        where: this.options.existingLocationData.postcode,
                        placeId: this.options.existingLocationData.place_id,
                        unitNumber: this.options.existingLocationData.unitNumber
                    };
                    this.disabled = true;
                    addressLookupController.postTo(postURL, geoLocation);
                }
            },
            onComplete: function onComplete (locationData) {
                if (this.lookup.inputs.fullAddress.dirty) {
                    geoLocation = {
                        latitude: locationData.latitude,
                        longitude: locationData.longitude,
                        postcode: locationData.postCode,
                        sublocality: locationData.sublocality,
                        state: locationData.state,
                        city: locationData.locality,
                        houseNo: locationData.streetNumber,
                        street: locationData.street,
                        where: locationData.postCode,
                        placeId: locationData.place_id,
                        unitNumber: locationData.unitNumber
                    };
                    addressLookupController.postTo(postURL, geoLocation);
                }
            }
        });
    },
    postTo: function (action, data) {
        var form = document.createElement('form'),
            key,
            input;
        form.method = 'post';
        form.action = action;
        for (key in data) {
            input = document.createElement('input');
            input.setAttribute('name', key);
            input.setAttribute('value', data[key] || '');
            form.appendChild(input);
        }
        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);
    }
};

window.AddressLookup = AddressLookup;

export default AddressLookupController;
